import {useEffect, useMemo, useState} from "react";

const AI_SCOPE_EVENT = "zofino:ai-scope-change";
let currentScope = null;

function emitScope(scope) {
    currentScope = scope;
    window.dispatchEvent(new CustomEvent(AI_SCOPE_EVENT, {detail: scope}));
}

export function usePublishAiScope(scope) {
    const serializedScope = JSON.stringify(scope || null);

    useEffect(() => {
        const nextScope = scope || null;
        emitScope(nextScope);
        return () => {
            if (currentScope === nextScope) emitScope(null);
        };
        // The serialized value deliberately controls updates for object/array scope values.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serializedScope]);
}

export function useActiveAiScope(baseContext) {
    const [publishedScope, setPublishedScope] = useState(currentScope);

    useEffect(() => {
        const handleChange = (event) => setPublishedScope(event.detail || null);
        window.addEventListener(AI_SCOPE_EVENT, handleChange);
        setPublishedScope(currentScope);
        return () => window.removeEventListener(AI_SCOPE_EVENT, handleChange);
    }, []);

    return useMemo(() => ({
        ...baseContext,
        ...(publishedScope || {}),
        filters: {
            ...(baseContext?.filters || {}),
            ...(publishedScope?.filters || {}),
        },
    }), [baseContext, publishedScope]);
}
